// removed by extract-text-webpack-plugin
module.exports = {"base":"SearchResult_base--2F11-","description":"SearchResult_description--2jgGt","name":"SearchResult_name--1v8kf"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/SearchResult/SearchResult.scss
// module id = 2276
// module chunks = 11